// ** Third Party Components
import { useTranslation } from "react-i18next";
import styled from "styled-components";

// ** Custom Components
import Link from "components/layout/Link";
import Block from "components/layout/Block";

const ShortMoreLinkStyled = styled(({ ...rest }) => <Block {...rest} />)`
	padding: 0.5rem 1rem 0.75rem;
	font-size: 85%;
`;

const ShowMoreLink = ({ to = "/", addGrid, lastElement, onClick }) => {
	const { t } = useTranslation(["common", "pages"]);
	return (
		<ShortMoreLinkStyled
			addGrid={addGrid}
			lastElement={lastElement}
			flex
			justifyEnd
			line="1rem"
		>
			<Link
				to={to}
				color="primary"
				underline
				onClick={(e) => {
					if (typeof onClick === "function") {
						onClick(e);
					}
				}}
			>
				{t("common:showMore")}
			</Link>
		</ShortMoreLinkStyled>
	);
};

export default ShowMoreLink;
